import { inject, Injectable } from '@angular/core';
import { VolunteerOfMonthMetric } from '@klubovna/api-client';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { VolunteersApiService } from '@presentationServices';
import { SentryLoggerService } from '@shared';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as VolunteersActions from './volunteers.actions';

@Injectable()
export class VolunteersEffects {
  private readonly actions$ = inject(Actions);
  private readonly volunteersApiService = inject(VolunteersApiService);
  private readonly sentryLogger = inject(SentryLoggerService);

  loadVolunteerOfMonth$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VolunteersActions.loadVolunteerOfMonth),
      mergeMap(() =>
        this.volunteersApiService.getVolunteerOfMonth(VolunteerOfMonthMetric.Points).pipe(
          map((volunteerOfMonth) => VolunteersActions.loadVolunteerOfMonthSuccess({ volunteerOfMonth })),
          catchError((error: unknown) => {
            this.sentryLogger.captureHttpError(error, {
              component: 'VolunteersEffects',
              action: 'loadVolunteerOfMonth',
            });
            return of(VolunteersActions.loadVolunteerOfMonthFailure({ error: 'Failed to load volunteer of month' }));
          }),
        ),
      ),
    ),
  );
}
